<template>
  <div class="active-user-marker" v-show="eventType || forceShow" :data-event-type="eventType">
    <i class="mdi mdi-account"></i>
  </div>
</template>

<script>
export default {
  name: "ActiveUserMarker",
  props: {
    eventType: {
      type: String
    },
    forceShow: {
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";
@import "~scss/utilities/mixins.scss";

.active-user-marker {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 1px solid $white;
  text-align: center;
  cursor: pointer;

  &[data-event-type="transport"] {
    background-color: #4a90e2;

    &.pulse {
      box-shadow: 0 0 0 rgba(#4a90e2, 0.24);
      animation: pulse-blue 2s infinite;
    }
  }

  &[data-event-type="stationary"] {
    background-color: #e57373;

    &.pulse {
      box-shadow: 0 0 0 rgba(#e57373, 0.4);
      animation: pulse-red 2s infinite;
    }
  }

  i {
    top: 1;
    position: relative;
    font-size: $size-small;
    color: $white;
  }
}
</style>

